import * as React from 'react';
import { useEffect } from 'react';

/** Material UI Packages. */
import { useMediaQuery, Typography } from '@mui/material';

/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/** Internal Components. */
import inactive from 'statics/images/inactive.png';
import { BREAKPOINTS } from 'shared/config/PageStyles';

import PageLayout from './pageLayout';

export default function InactivePage() {
    /** Destructuring values from useAuth0 hook. */
    const { logout } = useAuth0();

    /** Detecting window size for responsive web. */
    const isMediumScreen = useMediaQuery(`(max-width: ${BREAKPOINTS.MEDIUM}px)`);

    /** Set document title. */
    useEffect(() => {
        document.title = 'Inactive | Insight Logistics ';
    }, []);

    /** When logout button click, redirect to endpoint : /login.  */
    const handleLogout = () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    const contactEmail = (
        <Typography sx={{ fontSize: '1.3rem', display: 'inline' }}>
            <span>For more information, please contact us at </span>
            <span style={{ textDecoration: 'underline' }}>it@insightshippinginc.com</span>
        </Typography>
    );

    return (
        <PageLayout
            backgroundImage={inactive}
            title="Unauthorized:("
            description="Access to this website is restricted due to insufficient permissions."
            buttonText="Go Home"
            onButtonClick={handleLogout}
            isMediumScreen={isMediumScreen}
        >
            {contactEmail}
        </PageLayout>
    );
}
